var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import { Client as BaseClient } from '@datocms/cma-client';
import * as Resources from './generated/resources';

var Client =
/** @class */
function (_super) {
  __extends(Client, _super);

  function Client(config) {
    var _this = _super.call(this, config) || this;

    _this.uploads = new Resources.Upload(_this);
    return _this;
  }

  return Client;
}(BaseClient);

export { Client };